<aside class="acesso" aria-labelledby="acesso-titulo" #cartao>
  <div class="acesso-topo">
    <span class="acesso-avatar" aria-hidden="true">
      <i-lucide [name]="logado() ? 'user-round-check' : 'lock'" size="20"></i-lucide>
    </span>

    <h2 class="acesso-titulo" id="acesso-titulo">
      @if (logado()) {
        Olá, {{ nomeUsuario() }}
      } @else {
        Acesse para abrir<br />sua solicitação
      }
    </h2>
  </div>

  @if (logado()) {
    <p class="acesso-texto">
      Seus dados do cadastro do portal já foram carregados na etapa de identificação.
    </p>

    <button type="button" class="acesso-botao acesso-botao-primario" (click)="continuar.emit()">
      <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
      Continuar pedido
    </button>

    <button type="button" class="acesso-botao acesso-botao-anonimo" (click)="sair()">
      <i-lucide name="log-out" size="16" aria-hidden="true"></i-lucide>
      Sair
    </button>
  } @else {
    @if (anonimo()) {
      <p class="acesso-etiqueta-anonima">
        <i-lucide name="shield" size="14" aria-hidden="true"></i-lucide>
        Pedido anônimo em andamento
      </p>

      <p class="acesso-texto">
        Você pode entrar a qualquer momento para transformar este pedido em uma solicitação
        identificada.
      </p>
    } @else {
      <p class="acesso-etiqueta">Utilize a sua conta do portal</p>
    }

    @if (bloqueado() && mensagemBloqueio()) {
      <p class="acesso-bloqueio" role="status">
        <i-lucide name="circle-alert" size="14" aria-hidden="true"></i-lucide>
        {{ mensagemBloqueio() }}
      </p>
    }

    <form class="acesso-formulario" novalidate (submit)="entrar($event)">
      <label class="acesso-rotulo" for="acesso-documento">CPF/CNPJ</label>
      <input
        id="acesso-documento"
        #campoDocumento
        class="acesso-campo"
        type="text"
        inputmode="numeric"
        autocomplete="username"
        placeholder="000.000.000-00"
        [mask]="mascaraDocumento"
        [attr.aria-invalid]="tentouEntrar() && !documentoValido()"
        [attr.aria-describedby]="tentouEntrar() && !documentoValido() ? 'acesso-documento-erro' : null"
        [formField]="loginForm.documento"
      />
      @if (tentouEntrar() && !documentoValido()) {
        <p class="acesso-erro-campo" id="acesso-documento-erro">Informe um CPF ou CNPJ válido.</p>
      }

      <label class="acesso-rotulo" for="acesso-senha">Senha</label>
      <div class="acesso-senha">
        <input
          id="acesso-senha"
          class="acesso-campo acesso-campo-senha"
          [type]="senhaVisivel() ? 'text' : 'password'"
          autocomplete="current-password"
          placeholder="Digite sua senha"
          [attr.aria-invalid]="tentouEntrar() && !senhaValida()"
          [attr.aria-describedby]="tentouEntrar() && !senhaValida() ? 'acesso-senha-erro' : null"
          [formField]="loginForm.senha"
        />
        <button
          type="button"
          class="acesso-olho"
          [attr.aria-label]="senhaVisivel() ? 'Ocultar senha' : 'Mostrar senha'"
          [attr.aria-pressed]="senhaVisivel()"
          (click)="alternarSenha()"
        >
          <i-lucide [name]="senhaVisivel() ? 'eye-off' : 'eye'" size="18" aria-hidden="true"></i-lucide>
        </button>
      </div>
      @if (tentouEntrar() && !senhaValida()) {
        <p class="acesso-erro-campo" id="acesso-senha-erro">Senha é obrigatória.</p>
      }

      <p class="acesso-atalhos">
        <a
          class="acesso-link"
          href="https://sai3.io.org.br/Account/ForgotPassword"
          target="_blank"
          rel="noopener"
        >
          Esqueci a senha
        </a>
      </p>

      @if (erroLogin()) {
        <p class="acesso-erro" role="alert" aria-live="assertive">{{ erroLogin() }}</p>
      }

      <button type="submit" class="acesso-botao acesso-botao-primario" [disabled]="entrando()">
        <i-lucide name="log-in" size="16" aria-hidden="true"></i-lucide>
        {{ entrando() ? 'Entrando...' : 'Entrar com login' }}
      </button>
    </form>

    <a class="acesso-botao acesso-botao-govbr" href="#" (click)="entrarComGov($event)">
      <i-lucide name="globe" size="18" aria-hidden="true"></i-lucide>
      <img
        class="acesso-govbr-marca"
        ngSrc="assets/images/logo-gov.svg"
        width="62"
        height="18"
        alt="gov.br"
      />
    </a>

    @if (!anonimo()) {
      <button type="button" class="acesso-botao acesso-botao-anonimo" (click)="solicitarAnonimamente()">
        <i-lucide name="shield" size="16" aria-hidden="true"></i-lucide>
        Solicitar anonimamente
      </button>
    }
  }
</aside>
